// extracted by mini-css-extract-plugin
var _1 = "TableBuildingCell-modulecell__p87qu TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
var _2 = "TableBuildingCell-moduleeditButton__OQi1I TableCellEditButton-moduleedit__YZdJ_";
export { _1 as "cell", _2 as "editButton" }
